// Mirrors backend/app/scoring_config.py and SETTINGS_SCHEMA; pinned by
// backend/tests/test_mirror_parity.py. Two distinct defaults live here:
// DEFAULT_DECAY is the TLDR pipeline decay (tldr_decay_exponent), while
// SAVED_SEARCH_DEFAULT_DECAY is what a new saved search gets — they differ
// on purpose, so don't substitute one for the other.
export const DEFAULT_DECAY = 0.35;
export const DECAY_MIN = 0.0;
export const DECAY_MAX = 1.0;

export const DEFAULT_RELEVANCE_MULTIPLIER = 2.0;
export const RELEVANCE_MULT_MIN = 0.5;
export const RELEVANCE_MULT_MAX = 4.0;

// Slider step granularity for the two scoring sliders — a client-side
// decision shared with iOS (ScoringSliderSpec.swift) and Android
// (ScoringSliderSpec.kt, which encodes the same grid as Compose step
// counts); pinned across clients by backend/tests/test_mirror_parity.py.
export const DECAY_SLIDER_STEP = 0.005;
export const RELEVANCE_SLIDER_STEP = 0.01;

export const SAVED_SEARCH_DEFAULT_DECAY = 0.3;
export const SAVED_SEARCH_DEFAULT_RELEVANCE = 2.0;

export function formatDecay(value: number): string {
  return value.toFixed(3);
}

// "×" (U+00D7), not ASCII "x": iOS and Android render the multiply sign, and
// the three clients' relevance labels are pinned to agree — the iOS search
// composer once drifted to "x" while every sibling surface showed "×".
export function formatRelevanceMultiplier(value: number): string {
  return `${value.toFixed(2)}×`;
}

export interface SliderBounds {
  min: number;
  max: number;
}

export function multiplierToSliderPos(
  mult: number,
  bounds: SliderBounds = { min: RELEVANCE_MULT_MIN, max: RELEVANCE_MULT_MAX },
): number {
  const clamped = Math.min(bounds.max, Math.max(bounds.min, mult));
  return (clamped - bounds.min) / (bounds.max - bounds.min);
}

export function sliderPosToMultiplier(
  pos: number,
  bounds: SliderBounds = { min: RELEVANCE_MULT_MIN, max: RELEVANCE_MULT_MAX },
): number {
  return bounds.min + pos * (bounds.max - bounds.min);
}
